















































import Vue from 'vue'
import { app } from '@/firebase'
export default Vue.extend({
    name: 'ResetPassword',
    data: () => ({
        showPassword: false,
        passwordResetValid: false,
        isPasswordResetSuccessful: false,
        password: '',
        passwordConfirm: '',
    }),
    computed: {
        rules() {
            return {
                required: (v: string) => !!v || this.$i18n.t('common.formRules.required'),
                password: (v: string) => {
                    const pattern = /^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#=+-_,;:$?'"\\/<>$%^&*.])(?=.{6,})/
                    return pattern.test(v) || this.$i18n.t('common.formRules.password')
                },
                passwordConfirm: (v: string) => this.password === v || this.$i18n.t('common.formRules.passwordConfirm'),
            }
        },
        actionCode() {
            return this.$route.query.oobCode.toString()
        },
        devServer() {
            return process.env.VUE_APP_DEVSERVER
        },
    },
    methods: {
        resetPassword() {
            const auth = app.auth()
            auth.verifyPasswordResetCode(this.actionCode)
                .then(() =>
                    auth.confirmPasswordReset(this.actionCode, this.password).then(() => {
                        this.isPasswordResetSuccessful = true
                        setTimeout(() => this.$router.push('/#login'), 2000)
                    })
                )
                .catch(() => console.log('Invalid action code for resetting password.'))
        },

        clearConfirmInputField() {
            if (this.passwordConfirm) this.passwordConfirm = ''
        },
    },
})
